<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="img-back pull-left" href="javascript:window.history.go(-1)">返回</a>
        <h1>提醒设置</h1>
        <span class="pull-right icon-right orange" @click="saveHandsTime">保存</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page">
      <div class="remind-list">
        <ul class="list-group-item tinny">
          <li class="list-group" @click.prevent="showSelectStudent">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more text-right" >
              <span class="pull-left">提醒谁的家长看？</span>
              <span class="margin-x-15 gray ">{{studentSelectList.length}}</span>
            </a>
          </li>
          <li class="list-group" @click.prevent="openPicker('picker')">
              <div class="liner"></div>
              <a class="clearfix group-txt img-more text-right" >
                <span class="pull-left">什么时候提醒？</span>
                <span class="margin-x-15 gray ">{{info.handsTime}}</span>
              </a>
          </li>
          <li class="list-group" @click.prevent="isHideWeek = false">
              <div class="liner"></div>
              <a class="clearfix group-txt img-more text-right" >
                <span class="pull-left">重复</span>
                <span class="margin-x-15 gray font-12">
                  <span v-for="week in weekList" v-if="week.isChecked">
                    {{week.week}}&nbsp;&nbsp;
                  </span>
                </span>
              </a>
          </li>
        </ul>
        <span class="margin-15">提醒文字</span>
        <ul class="list-group-item tinny">
          <li class="list-group padding-15">
            <textarea style="height:120px;" class="font-12 gray" v-model="info.handsContent" maxlength="100" placeholder="默认：少儿之家温馨提醒您：请及时接孩子，您的宝贝在想你！"></textarea>
          </li>
        </ul>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <span class="block text-center padding-15" @click="deleteRemind">删除</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <!-- 重复 -->
    <div class="maskdiv" v-show="!isHideWeek" @click="isHideWeek = true">
      <div class="slider" @click.stop>
        <strong class="tit">重复</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in weekList">
            <li @click="item.isChecked = !item.isChecked">
              <div class="clearfix group-link"><span class="pull-left">{{item.week}}</span>
              <template v-if="item.isChecked">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
        <div class="text-center"><a class="button button-rounded button-line" @click.prevent="isHideWeek = true">确定</a></div>
      </div>
    </div>

    <mt-datetime-picker v-model="info.handsTime" type="time" @confirm="handleChange" :start-hour="6" ref="picker"></mt-datetime-picker>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  data () {
    return {
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_hands_remind_para: service.setPara('getHandsRemind'),
      save_hands_remind_para: service.setPara('saveHandsRemind'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      delete_remind_para: service.setPara('deleteRemind'),
      curcheId: 0,
      studentList: [],
      isHideSelectStudent: true,
      isHideWeek: true,
      remindTimeVisible: false,
      isGetStudentList: false,
      content: '',
      curcheHandsTimeId: 0,
      info: {},
      weekList: [{week: '周一', isChecked: false}, {week: '周二', isChecked: false}, {week: '周三', isChecked: false}, {week: '周四', isChecked: false}, {week: '周五', isChecked: false}, {week: '周六', isChecked: false}, {week: '周日', isChecked: false}]
    }
  },
  computed: {
    ...mapGetters({
      studentListX: 'getStudentsByFirstChar'
    }),
    studentSelectList: function () {
      let list = []
      for (let i = 0; i < this.studentList.length; i++) {
        if (this.studentList[i].students) {
          for (let j = 0; j < this.studentList[i].students.length; j++) {
            if (this.studentList[i].students[j].isChecked) {
              list.push(this.studentList[i].students[j])
            }
          }
        } else {
          if (this.studentList[i].isChecked) {
            list.push(this.studentList[i])
          }
        }
      }
      return list
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    this.curcheHandsTimeId = this.$route.params.curcheHandsTimeId
    // 获取园点学生数据
    this.curcheId = this.cookie_login_data.curcheId
    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.get_new_student_list_para.context = this
    this.$store.dispatch('receiveStudents', this.get_new_student_list_para)

    this.getHandsRemind()
  },
  methods: {
    ...mapMutations([
      'receiveStudents'
    ]),
    openPicker (picker) {
      this.$refs[picker].open()
    },
    handleChange: function (value) {
      this.info.handsTime = value
    },
    getHandsRemind: function () { // 获取提醒信息
      this.get_hands_remind_para.curcheHandsTimeId = this.curcheHandsTimeId
      let obj = {context: this, para: this.get_hands_remind_para, successFun: (response) => {
        this.info = response.data
        for (let i = 0; i < this.info.weekList.length; i++) {
          for (let j = 0; j < this.weekList.length; j++) {
            if (this.info.weekList[i].week == this.weekList[j].week) {
              this.weekList[j].isChecked = true
            }
          }
        }
        for (let j = 0; j < this.info.studentList.length; j++) {
          this.info.studentList[j].isChecked = true
          this.studentList.push(this.info.studentList[j])
        }
      }}
      service.request(obj)
    },
    saveHandsTime: function (para) { // 保存提醒设置
      let studentIdList = []
      let weekList = []
      for (let i = 0; i < this.studentSelectList.length; i++) {
        if (this.studentSelectList[i].isChecked) {
          studentIdList.push(this.studentSelectList[i].studentId)
        }
      }

      if (studentIdList.length == 0) {
        Toast('请选择要提醒的学生')
        return
      }

      for (let i = 0; i < this.weekList.length; i++) {
        if (this.weekList[i].isChecked) {
          weekList.push(this.weekList[i].week)
        }
      }

      if (weekList.length == 0) {
        Toast('请选择要重复的时间')
        return
      }

      if (this.info.handsTime == '') {
        Toast('请选择要提醒的时间')
        return
      }

      if ($.trim(this.info.handsContent) == '') {
        // Toast('请选择要提醒的内容')
        // return
        this.info.handsContent = '少儿之家温馨提醒您：请及时接孩子，您的宝贝在想你！'
      }

      this.save_hands_remind_para.studentIdList = studentIdList
      this.save_hands_remind_para.weekList = weekList
      this.save_hands_remind_para.handsTime = this.info.handsTime
      this.save_hands_remind_para.handsContent = this.info.handsContent
      this.save_hands_remind_para.curcheId = this.curcheId
      this.save_hands_remind_para.curcheHandsTimeId = this.curcheHandsTimeId
      let obj = {context: this, para: this.save_hands_remind_para, successFun: (response) => {
        Toast('编辑成功')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    deleteRemind: function () { // 删除提醒
      this.delete_remind_para.curcheHandsTimeId = this.curcheHandsTimeId
      let obj = {context: this, para: this.delete_remind_para, successFun: (response) => {
        Toast('删除成功')
        window.history.go(-1)
      }}
      service.request(obj)
    },
    showSelectStudent: function () { // 显示编入学生
      if (this.isGetStudentList > 0) { // 已经有关联学生数据
        this.isHideSelectStudent = false
        return
      }

      let jsonStr = JSON.stringify(this.studentListX)
      let list = JSON.parse(jsonStr)
      // for (var i = 0; i < list.length; i++) {
      //   list[i].isChecked = false
      //   for (let j = 0; j < this.info.studentList.length; j++) {
      //     if (this.info.studentList[j].studentId == list[i].studentId) {
      //       list[i].isChecked = true
      //       break
      //     }
      //   }
      // }
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].students.length; j++) {
          list[i].students[j].isChecked = false
          for (let z = 0; z < this.info.studentList.length; z++) {
            if (this.info.studentList[z].studentId == list[i].students[j].studentId) {
              list[i].students[j].isChecked = true
              break
            }
          }
        }
      }
      this.studentList = list
      this.isGetStudentList = true
      this.isHideSelectStudent = false
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      student.isChecked = !student.isChecked
    }
  }
}
</script>
<style scoped>
  .mint-popup-bottom{width:100vw;}
</style>



// WEBPACK FOOTER //
// remindEdit.vue?3431281e